import { useState } from 'react';
import Modal from './Modal';

export default function ParametersTab({ onNavigate = () => {} }) {
    const [step, setStep] = useState(0);
    const [openTutorial, setOpenTutorial] = useState(false);

    const next = () => setStep((s) => (s < steps.length - 1 ? s + 1 : s));
    const prev = () => setStep((s) => (s > 0 ? s - 1 : s));

    const steps = [
        {
            title: 'Vérifier les unités',
            body: 'Confirmez que les unités nécessaires (g, kg, L, pièce, etc.) existent. Ajoutez-en si besoin.',
            action: () => onNavigate('units'),
            actionLabel: 'Ouvrir Unités',
        },
        {
            title: 'Ajouter / vérifier les ingrédients',
            body: 'Créez ou mettez à jour les ingrédients avec leurs unités et coûts. Associez un fournisseur si nécessaire.',
            action: () => onNavigate('ingredients'),
            actionLabel: 'Ouvrir Ingrédients',
        },
        {
            title: 'Enregistrer un approvisionnement',
            body: 'Enregistrez un approvisionnement pour ajouter du stock et, si nécessaire, créer un numéro de lot.',
            action: () => onNavigate('supply'),
            actionLabel: 'Ouvrir Approvisionnement',
        },
        {
            title: 'Créer le plat',
            body: 'Créez le plat avec son nom et son prix; vous pourrez ensuite ajouter la recette.',
            action: () => onNavigate('plats'),
            actionLabel: 'Ouvrir Plats',
        },
        {
            title: 'Éditer la recette du plat',
            body: 'Ajoutez ingrédients ou composants à la recette du plat pour définir les quantités et unités.',
            action: () => onNavigate('recipes'),
            actionLabel: 'Ouvrir Recettes',
        },
        {
            title: 'Lots et versions (optionnel)',
            body: 'Gérez les lots pour suivre les numéros et dates d’expiration, et consultez l’historique des versions de recettes.',
            action: () => onNavigate('batches'),
            actionLabel: 'Ouvrir Lots',
        },
    ];

    return (
        <div className="space-y-6">
            <div className="rounded-3xl border border-green-200 bg-white p-6 shadow-sm">
                <h2 className="text-3xl font-semibold text-green-900">Paramètres</h2>
                <p className="mt-2 text-sm text-green-600">Regroupe la gestion du menu, des ingrédients et des réglages.</p>

                <div className="mt-6 grid gap-4 sm:grid-cols-2">
                    <div className="rounded-2xl border border-green-200 bg-white p-4 shadow-sm">
                        <h3 className="text-lg font-semibold text-green-900 mb-3">Gestion du menu</h3>
                        <ul className="space-y-3">
                            <li className="rounded-2xl border border-green-100 bg-green-50 p-4">
                                <button onClick={() => onNavigate('plats')} className="w-full text-left">
                                    <div className="font-semibold text-green-900">Plats & Menu</div>
                                    <div className="text-sm text-slate-600">Gérer les plats, prix et recettes</div>
                                </button>
                            </li>

                            <li className="rounded-2xl border border-green-100 bg-green-50 p-4">
                                <button onClick={() => onNavigate('recipes')} className="w-full text-left">
                                    <div className="font-semibold text-green-900">Recettes</div>
                                    <div className="text-sm text-slate-600">Plan de fabrication des plats</div>
                                </button>
                            </li>

                            <li className="rounded-2xl border border-green-100 bg-green-50 p-4">
                                <button onClick={() => onNavigate('components')} className="w-full text-left">
                                    <div className="font-semibold text-green-900">Composants</div>
                                    <div className="text-sm text-slate-600">Recettes réutilisables</div>
                                </button>
                            </li>
                        </ul>
                    </div>

                    <div className="rounded-2xl border border-green-200 bg-white p-4 shadow-sm">
                        <h3 className="text-lg font-semibold text-green-900 mb-3">Stock & références</h3>
                        <ul className="space-y-3">
                            <li className="rounded-2xl border border-green-100 bg-green-50 p-4">
                                <button onClick={() => onNavigate('ingredients')} className="w-full text-left">
                                    <div className="font-semibold text-green-900">Ingrédients</div>
                                    <div className="text-sm text-slate-600">Gérer stocks, fournisseurs et attributs</div>
                                </button>
                            </li>

                            <li className="rounded-2xl border border-green-100 bg-green-50 p-4">
                                <button onClick={() => onNavigate('supply')} className="w-full text-left">
                                    <div className="font-semibold text-green-900">Approvisionnement</div>
                                    <div className="text-sm text-slate-600">Enregistrer les achats, lots et réceptions</div>
                                </button>
                            </li>

                            <li className="rounded-2xl border border-green-100 bg-green-50 p-4">
                                <button onClick={() => onNavigate('units')} className="w-full text-left">
                                    <div className="font-semibold text-green-900">Unités</div>
                                    <div className="text-sm text-slate-600">Unités de mesure</div>
                                </button>
                            </li>

                            <li className="rounded-2xl border border-green-100 bg-green-50 p-4">
                                <button onClick={() => onNavigate('suppliers')} className="w-full text-left">
                                    <div className="font-semibold text-green-900">Fournisseurs</div>
                                    <div className="text-sm text-slate-600">Gérer fournisseurs</div>
                                </button>
                            </li>

                            <li className="rounded-2xl border border-green-100 bg-green-50 p-4">
                                <button onClick={() => onNavigate('productTypes')} className="w-full text-left">
                                    <div className="font-semibold text-green-900">Types de produit</div>
                                    <div className="text-sm text-slate-600">Catégories et types</div>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-6 rounded-2xl border border-green-100 bg-green-50 p-4">
                    <h3 className="font-semibold text-green-900">Guide rapide — Créer un plat</h3>
                    <p className="mt-2 text-sm text-slate-700">Liste concise des actions à effectuer pour créer un plat et assurer le suivi des stocks.</p>
                    <ol className="mt-4 list-decimal pl-5 space-y-3 text-sm text-slate-700">
                        {steps.map((s, idx) => (
                            <li key={idx} className="flex items-start justify-between">
                                <div>
                                    <div className="font-medium text-green-900">{s.title}</div>
                                    <div className="text-xs text-slate-600">{s.body}</div>
                                </div>
                                <div className="ml-4">
                                    <button onClick={() => s.action()} className="px-3 py-1 bg-amber-600 text-white rounded">{s.actionLabel}</button>
                                </div>
                            </li>
                        ))}
                    </ol>
                </div>
            </div>

            <Modal title={steps[step].title} open={openTutorial} onClose={() => setOpenTutorial(false)}>
                <div>
                    <p className="text-sm text-green-900">{steps[step].body}</p>
                    <div className="mt-4 flex justify-between items-center">
                        <div>
                            {step > 0 && <button onClick={prev} className="px-3 py-1 mr-2 bg-white border rounded">Précédent</button>}
                            {step < steps.length - 1 && <button onClick={next} className="px-3 py-1 bg-green-600 text-white rounded">Suivant</button>}
                        </div>
                        <div>
                            <button onClick={() => { steps[step].action(); setOpenTutorial(false); }} className="px-3 py-1 bg-amber-600 text-white rounded">{steps[step].actionLabel}</button>
                        </div>
                    </div>
                    <div className="mt-3 text-xs text-slate-600">Étape {step + 1} sur {steps.length}</div>
                </div>
            </Modal>
        </div>
    );
}
